import { RevertShiftChangesDocument } from '@frontend/graphql/mutations/revertShiftChanges.generated'

import { useRosterActionMutation } from './useRosterActionMutation'

const useRevertShiftChangesMutation = () =>
  useRosterActionMutation({
    document: RevertShiftChangesDocument,
    succeeded: (response) => Boolean(response?.revertShiftChanges?.success),
    errorCode: 'REVERT_ERROR',
    messageKey: 'errors.revert_failed',
  }).run

export default useRevertShiftChangesMutation
